<template>
	<div class="jmhome">

		<div class="nr">
			
			<div class="centre">
				<div class="top">
					<div class="bt">
						<img class="bt-img" src="/static/img/comm/home.png" />
						<div style="width: 40%;">{{zexiantu.title}}</div>
						<div>
							<RadioGroup  @on-change="onchange()" v-model="single">
								<Radio label="0">
									<span >每日收益</span>
								</Radio>
								<Radio  label="1">
									<span >每月收益</span>
								</Radio>
								<Radio  label="2">
									<span >每年收益</span>
								</Radio>
							</RadioGroup>
						</div>
					</div>
					<zexiantu v-if="hackResetzexiantu" :data1='zexiantu.data1' :minWidth="minWidth" :data2="zexiantu.data2" :date="zexiantu.date"></zexiantu>
				</div>
				
			</div>
			
		</div>
		<div class="tjan" v-if="single==0">
			<Button shape="circle" @click="shangyiyue">上一月</Button>
			<div class="tjan-je">{{year}}年{{month}}月-{{zxtMap.totalMoneyXz/100}}元</div>
			<Button shape="circle" @click="xiayiyue">下一月</Button>
		</div>
		<div class="tj" v-if="single==0">
			
			<div class="item">
				<div class="tj-title">本月总收益：</div>
				<div class="tj-je">{{zxtMap.totalMoney/100}}元</div>
			</div>
			
			<div class="item">
				<div class="tj-title">平均每日收益：</div>
				<div class="tj-je">{{zxtMap.average/100}}元</div>
			</div>
			<div class="item">
				<div class="tj-title">昨日收益：</div>
				<div class="tj-je">{{zxtMap.yesterday/100}}元</div>
			</div>
			<div class="item">
				<div class="tj-title">今日收益：</div>
				<div class="tj-je">{{zxtMap.today/100}}元</div>
			</div>
		</div>
		<div class="tjan" v-if="single==1">
			<Button shape="circle" @click="shangyinian">上一年</Button>
			<div class="tjan-je">{{year}}年-{{zxtMap.totalMoneyXz/100}}元</div>
			<Button shape="circle" @click="xiayinian">下一年</Button>
		</div>
		<div class="tj" v-if="single==1">
			<div class="item">
				<div class="tj-title">今年收益：</div>
				<div class="tj-je">{{zxtMap.totalMoney/100}}元</div>
			</div>
			<div class="item">
				<div class="tj-title">月平均收益：</div>
				<div class="tj-je">{{zxtMap.average/100}}元</div>
			</div>
			<div class="item">
				<div class="tj-title">本月收益：</div>
				<div class="tj-je">{{zxtMap.today/100}}元</div>
			</div>
			<div class="item">
				<div class="tj-title">上月收益：</div>
				<div class="tj-je">{{zxtMap.yesterday/100}}元</div>
			</div>
		</div>
		<div class="tj" v-if="single==2">
			<div class="item">
				<div class="tj-title">总收益：</div>
				<div class="tj-je">{{zxtMap.totalMoney/100}}元</div>
			</div>
			<div class="item">
				<div class="tj-title">年平均收益：</div>
				<div class="tj-je">{{zxtMap.average/100}}元</div>
			</div>
			<div class="item">
				<div class="tj-title">今年收益：</div>
				<div class="tj-je">{{zxtMap.today/100}}元</div>
			</div>
			<div class="item">
				<div class="tj-title">上年收益：</div>
				<div class="tj-je">{{zxtMap.yesterday/100}}元</div>
			</div>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import zexiantu from '@/components/comm/home/zexiantu.vue'
	export default {

		data() {
			return {
				year:2019,
				month:11,
				minWidth:document.body.clientWidth-350+'px',
				single:'0',
				hackResetzexiantu: false,
				zxtMap:{},
				
				zexiantu: {
					title: '数据统计',
					data1: ['每日收益', '每月收益','每年收益'],
					data2: [{
							name: '每日收益',
							type: 'line',
							stack: '总量',
							data: []
						}
					],
					date:[]
				},
			}
		},
		methods: {
			xiayiyue(){
				let _this=this
				if(_this.month==12){
					_this.year++
					_this.month=1
					_this.queryzexiantu()
				}else{
					_this.month++
					_this.queryzexiantu()
				}
				
			},
			shangyiyue(){
				let _this=this
				if(_this.month==1){
					_this.year--
					_this.month=12
					_this.queryzexiantu()
				}else{
					_this.month--
					_this.queryzexiantu()
				}
			},
			xiayinian(){
				let _this=this
				
				_this.year++
				_this.queryzexiantu()
				
			},
			shangyinian(){
				let _this=this
				_this.year--
				_this.queryzexiantu()
			},
			queryzexiantu() {
				let _this=this
				let url=''
				switch (_this.single){
					case '0':
					_this.zexiantu.data2[0].name='日收益'
					url=http.url + '/fin/report/comm/home/alliance/month'
						break;
					case '1':
					_this.zexiantu.data2[0].name='月收益'
					url=http.url + '/fin/report/comm/home/alliance/year'
						break;
					case '2':
					_this.zexiantu.data2[0].name='年收益'
					url=http.url + '/fin/report/comm/home/alliance'
						break;
					default:
						break;
				}
				
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: url,
				    data: {
						year:_this.year,
						month:_this.month
					},
					_this: _this,
					success: function(data) {
						_this.zxtMap=data.map
						_this.huizhiZexiantu("0")
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			huizhiZexiantu(){
				
				let _this=this
				_this.zexiantu.data2[0].data=_this.zxtMap.moneys
				_this.zexiantu.date=_this.zxtMap.times
				//重新渲染子组件
				this.hackResetzexiantu = false
				this.$nextTick(() => {
					this.hackResetzexiantu = true
				})
			},
			onchange(){
				let _this=this
				_this.queryzexiantu()
			},
		},
		components: {
			zexiantu
		},
		created() {
			let _this = this
			var date = new Date();
			_this.year=parseInt(date.getFullYear()); //获取完整的年份(4位)
			_this.month=parseInt(date.getMonth())+1; //获取当前月份(0-11,0代表1月)
			_this.queryzexiantu()
			
		}

	}
</script>
<style scoped lang="less">
	.jmhome {
		display: flex;
		flex-direction: column;
	}


	.nr {
		display: flex;
		justify-content: space-between;

		.left {
			.top {
				padding: 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}

			.down {
				padding: 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}
		}

		.centre {


			.top {
				padding: 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}

			.down {
				padding: 5px 5px 0px 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}
		}

		.right {}

	}
    .tjan{
		display: flex;
		justify-content: center;
		align-items: center;
		.tjan-je{
			margin: 0 50px;
		}
	}
	.tj{
		background-color: #F5F7F9;
		border-radius: 15px;
		padding: 10px;
		.item{
			display: flex;
			.tj-title{
				font-size: 20px;
			}
			.tj-je{
				font-size: 20px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/home/alliance/alliance1.vue